(function () {
  const stopVideo = (section) => {
    const videos = section.querySelectorAll('video');

    if (videos) {
      videos.forEach(video => {
        video.pause();
      });
    }
  };

  const playVideo = (section, width) => {
    const videos = section.querySelectorAll('video');
    const cards = section.querySelectorAll('.gallery-with-text__card');

    if (videos && cards) {
      cards.forEach(card => {
        if (card.querySelector('video')) {
          if (card.classList.contains('active') || width < 990)
            card.querySelector('video').play();
          else
            card.querySelector('video').pause();
        }
      });
    }

    const mobileSlides = section.querySelectorAll('.gallery-with-text__mobile-slide');
    if (mobileSlides.length) {
      mobileSlides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (!video) return;

        try {
          const swiper = slide.closest('.swiper')?.swiper;
          if (swiper && index === swiper.activeIndex && width < 990) {
            video.play();
          } else {
            video.pause();
          }
        } catch (e) {}
      });
    }
  };

  const galleryTextSlide = () => {
    $(".gallery-with-text__card").hover(function () {
      let $this = $(this);

      if (document.documentElement.clientWidth < 990) return;

      $this.addClass("active");
      $this.siblings(".gallery-with-text__card").removeClass("active");

      setTimeout(function () {
        $this
          .children(".gallery-with-text__info")
          .children(".link--overlay")
          .addClass("active");
        $this
          .siblings(".gallery-with-text__card")
          .children(".gallery-with-text__info")
          .children(".link--overlay")
          .removeClass("active");
      }, 100);

      playVideo($this.closest('.gallery-with-text-section')[0], document.documentElement.clientWidth);
    });
  };

  const initDesktopSection = () => {
    const sections = document.querySelectorAll('.gallery-with-text-section');

    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting)
          playVideo(entry.target, entry.boundingClientRect.width);
        else
          stopVideo(entry.target);
      });
    });

    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      let widthSlide = '100%';

      if (document.documentElement.clientWidth >= 990) {
        entry.target.querySelectorAll('.gallery-with-text__card').forEach(card => {
          if (card.classList.contains('active')) {
            widthSlide = card.getBoundingClientRect().width;
          }
        });
        entry.target.style.setProperty("--width-slide", `${widthSlide}px`);
      } else {
        entry.target.style.setProperty("--width-slide", '100%');
      }

      playVideo(entry.target, entry.contentRect.width);
    });

    sections.forEach(section => {
      sectionObserver.observe(section);
      sectionResizeObserver.observe(section);
    });

    galleryTextSlide();
  };

  const initMobileSlider = () => {
    if (typeof Swiper === 'undefined') return;

    document.querySelectorAll('.gallery-with-text__mobile-slider').forEach((sliderEl) => {
      if (sliderEl.swiper) return;

      const section = sliderEl.closest('.gallery-with-text-section');
      if (!section) return;

      const prevEl = section.querySelector('.gallery-with-text__mobile-prev');
      const nextEl = section.querySelector('.gallery-with-text__mobile-next');

      const mobileSlides = Number(sliderEl.dataset.mobileSlides) || 1;
      const tabletSlides = Number(sliderEl.dataset.tabletSlides) || 1;

      new Swiper(sliderEl, {
        slidesPerView: mobileSlides,
        spaceBetween: 12,
        speed: 500,
        watchOverflow: true,
        allowTouchMove: true,
        simulateTouch: true,
        grabCursor: true,
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        breakpoints: {
          576: {
            slidesPerView: tabletSlides,
            spaceBetween: 16
          }
        },
        on: {
          init: function () {
            playVideo(section, document.documentElement.clientWidth);
          },
          slideChange: function () {
            playVideo(section, document.documentElement.clientWidth);
          }
        }
      });
    });
  };

  const initSection = () => {
    initDesktopSection();
    initMobileSlider();
  };

  document.addEventListener("shopify:section:load", function () {
    initSection();
  });

  initSection();
})();